import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import PublicLayout from "../components/layout/PublicLayout";
import Loader from "../components/ui/Loader";

// Lazy load all pages
const Home = lazy(() => import("../pages/public/Home"));
const About = lazy(() => import("../pages/public/About"));
const Team = lazy(() => import("../pages/public/Team"));
const Campaigns = lazy(() => import("../pages/public/Campaigns"));
const OurWork = lazy(() => import("../pages/public/OurWork"));
const Impact = lazy(() => import("../pages/public/Impact"));
const Resources = lazy(() => import("../pages/public/Resources"));
const GetInvolved = lazy(() => import("../pages/public/GetInvolved"));
const Partners = lazy(() => import("../pages/public/Partners"));
const Contact = lazy(() => import("../pages/public/Contact"));

// 404 page
const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-primary text-center px-4">
    <div>
      <p className="font-display font-black text-8xl text-secondary mb-4">404</p>
      <h1 className="font-display text-3xl text-white uppercase mb-4">Page Not Found</h1>
      <a href="/" className="btn-primary inline-block">Back to Home</a>
    </div>
  </div>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <About /> },
      { path: "about/team", element: <Team /> },
      { path: "campaigns", element: <Campaigns /> },
      { path: "our-work", element: <OurWork /> },
      { path: "impact", element: <Impact /> },
      { path: "resources", element: <Resources /> },
      { path: "get-involved", element: <GetInvolved /> },
      { path: "partners", element: <Partners /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

export default router;
